// extracted by mini-css-extract-plugin
module.exports = {"list":"_2PAKAlW-xGjEXk8Q0xXZP2"};